module.exports = "/group_create-ea3a50cdc8894252181b05083afcbca7.svg";